var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"show-event-dot-mock",style:(`background: ${_vm.warningColor}; width: ${_vm.size}px; height: ${_vm.size}px`)})
}
var staticRenderFns = []

export { render, staticRenderFns }